import { Api } from 'utils';

class AdvertisingService {
		
	static admin = {
		get: async (params?: any) => Api.createResponse('admin/advertisements',params),
		create: async (params?: any) => Api.createResponse('admin/advertisements/create',params),
		changeStatus: async (params?: any) => Api.createResponse('admin/advertisements/change-status',params),
		delete: async (params?: any) => Api.createResponse('admin/advertisements/delete',params)
	}

}

export default AdvertisingService;